import React from 'react';
import { Divider } from '@material-ui/core';
import { FuseAnimateGroup } from '@fuse';
import Widget1 from '../../widgets/Widget1';
import Widget6 from '../../widgets/Widget6';
import Widget7 from '../../widgets/Widget7';
import * as colors from '@material-ui/core/colors';

const ClusterInfoTab = ({ 
	queue, 
	nodes, 
	jobsWidgetData,
	activities 
}) => {
	if (!queue || !nodes) return null;

	return (
		<FuseAnimateGroup enter={{ animation: 'transition.slideUpBigIn' }}>
			<div className="flex flex-col sm:flex-row ">
				<div className="flex flex-1 flex-col w-full sm:w-3/4">
					<div className="flex flex-col sm:flex-row w-full">
						<div className="widget flex w-full sm:w-1/3 p-2 ">
							<Widget1
								id="cluster_view_jobs-widget"
								color="red"
								currentRange="total"
								ranges={{
									total: 'Total',
									day: 'Today',
									month: 'This Month',
									year: 'This Year'
								}}
								data={{
									total: jobsWidgetData.total,
									day: jobsWidgetData.day,
									month: jobsWidgetData.month,
									year: jobsWidgetData.year
								}}
								label="Jobs Submitted"
								extraLabel="Blocked Jobs"
								extraData={queue.counts.blocked}
							/>
						</div>
						<div className="widget flex w-full sm:w-1/3 p-4">
							<Widget1
								id="cluster_view_queue-widget"
								color="purple"
								currentRange="r"
								ranges={{ r: 'Running', q: 'Queued' }}
								data={{
									r: queue.counts.running,
									q: queue.counts.queued
								}}
								label="Queue"
								extraLabel="Total Jobs"
								extraData={queue.counts.total}
							/>
						</div>
						<div className="widget flex w-full sm:w-1/3 p-4 ">
							<Widget1
								id="cluster_view_nodes-widget"
								color="green"
								currentRange="a"
								ranges={{ a: 'Available', b: 'Busy', d: 'Down', o: 'Offline' }}
								data={{
									a: nodes?.counts?.available,
									b: nodes?.counts?.busy,
									d: nodes?.counts?.down,
									o: nodes?.counts?.offline
								}}
								label="Nodes"
								extraLabel="Total Nodes"
								extraData={nodes?.counts?.total}
							/>
						</div>
					</div>
					<Divider variant="middle" />
					<div className="flex flex-col lg:flex-row mt-2">
						<div className="widget flex sm:flex-row w-1/2 ml-8 ">
							<Widget6
								title="Nodes"
								data={{
									labels: ['Available Nodes', 'Busy Nodes', 'Down Nodes'],
									datasets: [
										{
											data: [nodes?.counts?.available, nodes?.counts?.busy, nodes?.counts?.down],
											backgroundColor: [colors.indigo[500], colors.yellow[500], colors.orange[500]],
											hoverBackgroundColor: [colors.indigo[300], colors.yellow[300], colors.orange[300]]
										}
									]
								}}
							/>
						</div>
						<div className="widget flexsm:flex-row w-1/2  ml-8">
							<Widget6
								title="Workload"
								data={{
									labels: ['Running Jobs', 'Queued Jobs', 'Blocked Jobs'],
									datasets: [
										{
											data: [queue.counts.running, queue.counts.queued, queue.counts.blocked],
											backgroundColor: [colors.green[500], colors.purple[500], colors.red[500]],
											hoverBackgroundColor: [colors.green[300], colors.purple[300], colors.red[300]]
										}
									]
								}}
							/>
						</div>
					</div>
				</div>
				<div className="flex flex-wrap w-full md:w-320">
					<div className="widget w-full p-8">
						<Widget7
							id="cluster_view_activities-widget"
							title="Activities Log"
							currentRange="all"
							ranges={{
								all: 'All',
								job: 'Job',
								cluster: 'Cluster',
								user: 'User'
							}}
							data={activities}
						/>
					</div>
				</div>
			</div>
		</FuseAnimateGroup>
	);
};

export default ClusterInfoTab;
